import { materialLightColors } from "../constants/dataConstants";


export const buildFormData = (
  formData: FormData,
  data: any,
  parentKey?: any
) => {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    const value = data == null ? "" : data;

    formData.append(parentKey, value);
  }
};

export const getLogoPlaceHolder = (name: string) => {
  return name
    ? name
      .split(" ")
      ?.map(function (str) {
        return str ? str[0].toUpperCase() : "";
      })
      .join("")
    : "";
};

export const getPartnerStatusTextStyle = (status: string) => {
  switch (status) {
    case "Suitable":
      return {
        background: "#FEFFD1",
        color: "#DC6803",
      };
    case "Interested":
      return {
        background: "#FEF3F2",
        color: "#F04438",
      };
    case "Accepted":
      return {
        background: "#D1FADF",
        color: "#039855",
      };
    case "Recommended":
      return {
        background: "#D1E9FF",
        color: "#1570EF",
      };
    default:
      return {};
  }
};

export const getFlagIcon = (countryName: string | "") => {
  let country = countryName.toLowerCase();
  switch (country) {
    case "australia":
      return (
        <img className="listicon" src="/svgs/flags/australia.svg" alt="flag" />
      );

    case "china":
      return (
        <img className="listicon" src="/svgs/flags/china.svg" alt="flag" />
      );

    case "hong kong":
      return (
        <img className="listicon" src="/svgs/flags/hong-kong.svg" alt="flag" />
      );

    case "india":
      return (
        <img className="listicon" src="/svgs/flags/india.svg" alt="flag" />
      );

    case "indonesia":
      return (
        <img className="listicon" src="/svgs/flags/indonesia.svg" alt="flag" />
      );

    case "japan":
      return (
        <img className="listicon" src="/svgs/flags/japan.svg" alt="flag" />
      );

    case "philippines":
      return (
        <img
          className="listicon"
          src="/svgs/flags/philippines.svg"
          alt="flag"
        />
      );

    case "singapore":
      return (
        <img className="listicon" src="/svgs/flags/singapore.svg" alt="flag" />
      );

    case "south korea":
      return (
        <img
          className="listicon"
          src="/svgs/flags/south-korea.svg"
          alt="flag"
        />
      );

    case "taiwan":
      return (
        <img className="listicon" src="/svgs/flags/taiwan.svg" alt="flag" />
      );

    case "thailand":
      return (
        <img className="listicon" src="/svgs/flags/thailand.svg" alt="flag" />
      );

    case "vietnam":
      return (
        <img className="listicon" src="/svgs/flags/vietnam.svg" alt="flag" />
      );
    case "malaysia":
      return (
        <img className="listicon max-w-[28px]" src="/images/malaysia.png" alt="flag" />
      );

    default:
      return <></>;
  }
};

export const getPartnerStatusStyle = (status: string) => {
  switch (status) {
    case "new":
      return "blue";

    case "approved":
      return "success";

    case "call scheduled":
      return "success";

    case "invited":
      return "warning";

    case "activated":
      return "success";

    case "information requested":
      return "warning";

    case "call requested":
      return "warning";

    case "information submitted":
      return "success";

    case "due diligence completed ":
      return "success";

    default:
      return "";
  }
};


export const abbreviateNumber = (value: number) => {
  var newValue: any = value;
  if (value >= 1000) {
    var suffixes = ["", "k", "m", "b", "t"];
    var suffixNum = Math.floor(("" + value).length / 3);
    var shortValue: any = '';
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision));
      var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
      if (dotLessShortValue.length <= 2) { break; }
    }
    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}

export const formatSizeBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return "0 B";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const avatarBg = (chars: string) => {
  if (!chars) {
    return "#B2DDFF"
  }

  // Return the number if the first character is numeric
  if (/^\d/.test(chars)) {
    return Number(chars[0]); // Return just the first digit
  }

  // If first character is not alphanumeric, return it directly
  if (!/^[A-Za-z0-9]/.test(chars[0])) {
    return chars[0];
  }

  // Ensure the input is between 1 and 5 characters long and contains only alphabet letters
  if (chars.length < 1 || chars.length > 5 || !/^[A-Za-z]+$/.test(chars)) {
    throw new Error(
      "Input should be a string with 1 to 5 alphabetic letters."
    );
  }

  // Normalize input to uppercase letters
  const normalizedLetters = chars.toUpperCase();

  // Calculate the sum of the character positions to determine which color to pick
  const colorIndex = normalizedLetters.split("").reduce((sum, letter) => {
    const letterIndex = letter.charCodeAt(0) - "A".charCodeAt(0);
    return sum + letterIndex;
  }, 0);

  // Get a color from the materialLightColors object based on the computed index
  const colorKeys = Object.keys(materialLightColors);
  const color = materialLightColors[colorKeys[colorIndex % colorKeys.length]];

  return color;
};

export const formatAmount = (value: number) => {
  if (typeof value === "string" && /[a-zA-Z]/.test(value)) {
    return value;
  }

  return value
    ? new Intl.NumberFormat("en-SG", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      style: "currency",
      currency: "SGD",
    }).format(Number(value || 0))
    : "";
};

export const isValidURL = (value: string) => {
  const pattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/\S*)?$/;
  return pattern.test(value);
}

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
  return `${value} ${sizes[i]}`;
};

const colorPalette = [
  { light: '#D1E9FF', dark: '#175CD3' }, // A
  { light: '#D1FADF', dark: '#027A48' }, // B
  { light: '#FDEDD6', dark: '#C4320A' }, // C
  { light: '#F3F9FF', dark: '#194185' }, // D
  { light: '#F3F3F3', dark: '#525252' }, // E
  { light: '#FFE4E8', dark: '#C01048' }, // F
  { light: '#FFF2CC', dark: '#A35F00' }, // G
  { light: '#E9D7FE', dark: '#7A32F0' }, // H
  { light: '#F2F4F7', dark: '#344054' }, // I
  { light: '#FFD6E7', dark: '#C11574' }, // J
  { light: '#DCFCE7', dark: '#15803D' }, // K
  { light: '#FEF3C7', dark: '#B45309' }, // L
  { light: '#E0F2FE', dark: '#0284C7' }, // M
  { light: '#EDE9FE', dark: '#6D28D9' }, // N
  { light: '#FFFBEB', dark: '#CA8A04' }, // O
  { light: '#FFEFEA', dark: '#C2410C' }, // P
  { light: '#FCE7F3', dark: '#C026D3' }, // Q
  { light: '#ECFDF3', dark: '#047857' }, // R
  { light: '#E0EFF9', dark: '#0369A1' }, // S
  { light: '#FEF2F2', dark: '#991B1B' }, // T
  { light: '#F5F3FF', dark: '#5B21B6' }, // U
  { light: '#FFF7ED', dark: '#C2410C' }, // V
  { light: '#E2E8F0', dark: '#1E293B' }, // W
  { light: '#FAE8FF', dark: '#9333EA' }, // X
  { light: '#F0FDF4', dark: '#15803D' }, // Y
  { light: '#F9FAFB', dark: '#111827' }  // Z
];

export const getColorByLetter = (letter: string) => {
  if (!letter) {
    return {
      backgroundColor: colorPalette[0].light,
      color: colorPalette[0].dark
    }
  }
  const index = letter.toLowerCase().charCodeAt(0) - 97;
  if (index < 0 || index >= colorPalette.length) {
    throw new Error('Input must be a letter A-Z');
  }

  return {
    backgroundColor: colorPalette[index].light,
    color: colorPalette[index].dark
  };
};

export const getColorByObjectId = (id: string) => {
  if (!id || typeof id !== 'string') {
    return {
      backgroundColor: colorPalette[0].light,
      color: colorPalette[0].dark
    };
  }

  // Simple hash function to convert string into number
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }

  const index = Math.abs(hash) % colorPalette.length;

  return {
    backgroundColor: colorPalette[index].light,
    color: colorPalette[index].dark
  };
};